module.exports = __webpack_public_path__ + "insta.png?0458f1a962ed7860da63b4bec3b8898c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insta.png
// module id = 70
// module chunks = 0